import { queries } from '../lib/supabase/queries';

export const packagesService = {
  async getAll() {
    return queries.packages.getAll();
  },

  async getActive() {
    return queries.packages.getActive();
  },

  async create(pkg) {
    return queries.packages.create(pkg);
  },

  async update(id, updates) {
    return queries.packages.update(id, updates);
  },

  async delete(id) {
    return queries.packages.delete(id);
  },
};

export default packagesService;
